import {
  deleteOrgProviderCredentials,
  getOrganizationProviders,
  getProvidersConfig,
} from "@/api/organization-providers"

import { IOrganizationProvider } from "@/types/organization-providers"
import { ProvidersType } from "@/types/providers.types"
import { useState } from "react"

interface IUseOrgProviders {
  fetchOrganizationProviders: (withConfig?: boolean) => Promise<any>
  removeOrgProvider: (id: string) => Promise<any>
  updateSingleOrganizationProvider: (orgProvider: IOrganizationProvider) => void
  orgProviders: IOrganizationProvider[]
  providersConfig: { provider: ProvidersType; fields: any }[]
  isLoading: boolean
}

export const useOrgProviders = (): IUseOrgProviders => {
  const [orgProviders, setOrgProviders] = useState<IOrganizationProvider[]>([])
  const [providersConfig, setProvidersConfig] = useState<any>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const removeOrgProvider = async (id: string) => {
    try {
      await deleteOrgProviderCredentials(id)
      setOrgProviders((state) => {
        return [...state.filter((orgProvider) => orgProvider.id !== id)]
      })
    } catch (error) {
      console.log(error + " deleting org provider")
    }
  }

  const fetchOrganizationProviders = async (withConfig?: boolean) => {
    setIsLoading(true)
    try {
      const { data: providers } = await getOrganizationProviders()

      if (withConfig) {
        const { data: providerConfigs } = await getProvidersConfig()
        setProvidersConfig(providerConfigs)
      }

      setOrgProviders(providers)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const updateSingleOrganizationProvider = (orgProvider: IOrganizationProvider) => {
    const filteredOrgProviders =
      orgProviders?.filter((currentOrgProvider) => currentOrgProvider.provider !== orgProvider.provider) || []

    setOrgProviders([...filteredOrgProviders, orgProvider])
  }

  return {
    fetchOrganizationProviders,
    removeOrgProvider,
    updateSingleOrganizationProvider,
    orgProviders,
    providersConfig,
    isLoading,
  }
}
